const loginValidator = require('../../modules/users/login_validator');
const trackingUtils = require('../../modules/utils/tracking.utils');
const tagManagement = require('../../modules/utils/tag_management.utils');
const priceUtils = require('../../modules/utils/price.utils');
const isUserDTOMember = require('../../modules/helpers/user.js').isUserDTOMember;
const {getRememberMeCookieField, hasRememberMeCookie} = require('od-modules/utils/sso.utils');
const MIN_DISCOUNT = -4.99;
const TRACKING_ACTION_UNLOCKED = 'unlocked';
const TRACKING_ACTION_WIDGET_ERROR = 'prime_widget_error';
const TRACKING_CATEGORY = 'flights_pax_page';
const {getKeyMembershipType} = require('./membership_subscription_utils');
const {PRODUCT_BASIC, LIGHTBOX_TRACK_LABELS, VARIATIONS} = require('./membership_subscription.constants');
const {translateBooleanToString} = require('od-modules/utils/membership_utils');

const showSubscriptionWidgetDesktop = (options) => options.isMembershipProductEnabled && !options.isMembershipPrimeInPayment;

module.exports = Odigeo.View.extend({
    slctrs: {
        alertWarningFields: '.alert_warning_fields',
        allInputs: '[data-name]:not([type="hidden"])',
        alreadyAMember: '.already_a_member',
        lightboxMember: '.lightbox_member',
        lightboxSaveInformation: '.lightbox_save_information',
        memberSelectTravellers: '.member_select_travellers',
        membershipContainer: '.membership_container',
        membershipMemberPrice: '#membership-member-price',
        membershipNonMemberPrice: '#membership-non-member-price',
        membershipPassword: '.membership_password',
        membershipPasswordContainer: '.membership_password_container',
        membershipPasswordError: '.membership_password_error',
        passwordViewerIcon: '.password_viewer_icon',
        prismaInput: '.prisma_input_group',
    },

    selectors: {
        productBasicSelector: '.membership_product_basic',
        lightboxSelector: '.membership_lightbox_member',
        productAddedSelector: '.membership_product_added',
    },

    events: {
        'change #membership-member-price': 'onForcedSelectionMemberChange',
        'change #membership-non-member-price': 'onForcedSelectionMemberChange',
        'tap .add_membership_product': 'onAddMembershipProduct',
        'tap .continue_with_prime': 'onContinueWithPrime',
        'tap .delete_membership': 'onDeleteMembership',
        'tap .membership_perks_link': 'onMembershipPerksLink',
        'tap .membership_widget_login': 'onMembershipWidgetLogin',
        'tap .lightbox_member_close': 'onCloseLightboxMember',
        'tap .lightbox_member': 'onCloseLightboxMemberTappingOutside',
        'tap .lightbox_save_information_close': 'onCloseLightboxSaveInformation',
        'tap .link_save_information': 'onSaveInformationClick',
        'tap .open_login_form': 'onOpenLoginForm',
        'tap .password_icon': 'onPasswordIconClick',
        'tap .want_be_member': 'onMemberButtonClick',
        'tap .terms_and_conditions': 'onTermsAndConditionsClick',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
    },

    init() {
        this.options = Odigeo.Utils.parseOptions(this.widget.options);
        const isUserMember = getRememberMeCookieField('isMembership') === 'true';
        const isUserLogged = hasRememberMeCookie();
        this.options = Odigeo._.extend({}, this.options, {isUserMember}, {isUserLogged});
        this.bindEvents(this.options);
        this.setInitialState();
        return this;
    },

    renderWrapper() {
        this.setTemplate(this.$el, 'wrapper');
    },

    bindEvents(options) {
        if (!this.checkConditionToShowWidget(options)) {
            this.trackingWidgetNotDisplayedOrPriceIsZero(options);
            return;
        }
        this.renderWrapper();
        Odigeo.trigger(`${this.widget.id}:trackMembersipPrices`);
        const templateRenderFnc = this.model.isProductStoredInSession() ? this.renderProductAddedTemplate : this.renderProductBasicFactory;
        const updatePricesAndRender = Odigeo._.flowRight(Odigeo._.bind(templateRenderFnc, this));
        this.listenTo(this.model, 'change:allPriceFromBackend', updatePricesAndRender);
        this.listenTo(this.model, 'change:membershipPriceIsZero', this.trackingWidgetNotDisplayedOrPriceIsZero);
    },

    checkConditionToShowWidget(options) {
        return showSubscriptionWidgetDesktop(options);
    },

    trackingWidgetNotDisplayedOrPriceIsZero() {
        let options = this.options;
        const subscriptionPrice = Number(this.model.get('allPriceFromBackend'));
        options = translateBooleanToString(options);
        const membershipTrackLabel = 'widget_not_shown' +
            `_smooth:F` +
            `_pay:${options.isMembershipPrimeInPayment}` +
            `_hide:F` +
            `_log:${options.isUserLogged}` +
            `_prime:${options.isUserMember}` +
            `_zero:${subscriptionPrice === 0 ? 'T' : 'F'}`;
        trackingUtils.trackEventWithCategory(TRACKING_CATEGORY, TRACKING_ACTION_WIDGET_ERROR, membershipTrackLabel);
    },

    setInitialState() {
        let state = this.options.isPriceWithoutDiscountSelected ? 'no-prime' : 'prime';
        state = this.model.get('isUserLoggedIn') ? `${state}-log` : state;
        this.model.set('state', state);
    },

    onFocusInput(e) {
        $(e.target).closest(this.slctrs.prismaInput).addClass('focused');
    },

    onBlurInput(e) {
        $(e.target).closest(this.slctrs.prismaInput).removeClass('focused');
    },

    checkPreviouslyAddedProduct() {
        if (this.model.isProductStoredInSession()) {
            this.model.removeAndAddProduct();
            this.renderProductAddedTemplate();
        }
    },

    renderProductBasicFactory() {
        const {isPrimeMobile} = Odigeo.Membership;
        const membershipType = this.model.get('membershipType');
        const {subscriptionPrice, membershipDiscount, membershipDiscountNumber} = this.buildParams();
        this.renderProductBasicTemplate(subscriptionPrice, membershipDiscount, membershipDiscountNumber, membershipType, isPrimeMobile);
    },

    renderProductBasicTemplate(subscriptionPrice, membershipDiscount, membershipDiscountNumber, membershipType, isPrimeMobile) {
        const {displayLightMembershipSubscriptionMobile} = this.options;
        const formattedPrice = Odigeo.Utils.formatCurrency(subscriptionPrice);
        const productBasic = this.buildProductBasicKeys(membershipType, membershipDiscountNumber);
        const updateProductBasicKeys = this.replaceArgsProductBasicKeys(productBasic, formattedPrice, membershipDiscount);
        this.setTemplate(this.$cachedSelectors.productBasicSelector, PRODUCT_BASIC, {
            translations: {
                ...productBasic,
                ...updateProductBasicKeys,
                displayLightMembershipSubscriptionMobile,
                isPrimeMobile,
            },
            keys: this.keys,
        });
    },

    getMembershipTrackLabel(trackingType, dataMember) {
        return dataMember.isLogged ? LIGHTBOX_TRACK_LABELS[trackingType]['LOGGED'] :
            LIGHTBOX_TRACK_LABELS[trackingType][dataMember.status];
    },

    trackGetMembershipLightBox(trackingType, dataToUse) {
        const dataMember = Odigeo._.isEmpty(dataToUse) ? this.model.toJSON().member : dataToUse;
        const membershipTrackLabel = this.getMembershipTrackLabel(trackingType, dataMember)
            + (trackingType === 'password_error' ? '' : `_sce:${this.model.get('state')}`);
        if (!Odigeo._.isEmpty(membershipTrackLabel)) {
            trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, membershipTrackLabel, null, trackingType === 'widget_appears');
        }

        this.updateScenario(dataMember);
    },

    updateScenario(dataMember) {
        if (!Odigeo._.isEmpty(this.model.get('scenario'))) {
            return;
        }
        const scenarioTrackLabels = {
            NOT_REGISTERED: 'no-log-no-sub',
            REGISTERED: 'no-log-no-sub-upg',
            PREMIUM: 'sub-no-log',
            LOGGED: 'log-no-sub',
        };
        let sceTrackLabel = dataMember.isLogged ?
            scenarioTrackLabels['LOGGED'] :
            scenarioTrackLabels[dataMember.status];
        this.model.set('scenario', sceTrackLabel);
    },

    renderLightBoxTemplate() {
        const membershipType = this.model.get('membershipType');
        const {formattedPrice} = this.buildParams();
        const lightbox = this.buildLightboxKeys(membershipType);
        const updatedLightboxKeys = this.replaceArgsLightboxKeys(lightbox, formattedPrice);
        const model = this.model.toJSON();
        this.setTemplate(this.$cachedSelectors.lightboxSelector, 'lightbox', {
            ...lightbox,
            ...updatedLightboxKeys,
            ...model,
        });
    },

    renderProductAddedTemplate() {
        this.$cachedSelectors.productBasicSelector.empty();
        this.model.set('isPrimePriceSelected', true);
        const {isPrimeMobile} = this.options;
        const membershipType = this.model.get('membershipType');
        this.setTemplate(this.$cachedSelectors.productAddedSelector, 'productAdded', {
            isPrimeMobile,
            ...this.buildProductAddedKeys(membershipType),
        });
    },

    buildProductAddedKeys(membershipType) {
        return {
            prodAddedStepFourText: this.keys[getKeyMembershipType('prodAddedStepFourText', membershipType)],
        };
    },

    alertDisclaimer(mustAppearDisclaimer) {
        this.$el.find(this.slctrs.alertWarningFields).toggleClass('odf-hidden', !mustAppearDisclaimer);
        if (mustAppearDisclaimer) {
            trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'add_membership_clicked_FE_error');
        }
    },

    hideWidget(isUserLoggedIn) {
        this.model.updateProduct('remove', isUserLoggedIn);
        this.$el.find(this.slctrs.membershipContainer).empty();
    },

    onAddMembershipProduct() {
        this.trackGetMembershipLightBox('click_member');
        const fieldErrors = loginValidator.checkValidity(this.$el.find(this.slctrs.allInputs), this.$widget);
        if (Odigeo._.isEmpty(fieldErrors)) {
            this.setMemberSelected();
            this.trigger('updateProduct');
            this.onCloseLightboxMember();
            this.renderProductAddedTemplate();
            tagManagement.fireEvent('click_prime', 'added_prime', 'true');
        } else {
            this.showPasswordError(fieldErrors[0]);
            this.trackGetMembershipLightBox('password_error');
        }
    },

    onCloseLightboxMemberTappingOutside(e) {
        if ($(e.target).hasClass('lightbox_member')) {
            this.onCloseLightboxMember();
        }
    },

    onCloseLightboxMember() {
        Odigeo.UIElements.toggleWidgetsDialogs(this.widget.id, false);
        this.$el.find(this.$cachedSelectors.lightboxSelector).removeClass('open');
        Odigeo.trigger(`${this.widget.id}:openOrCloseMembershipDialog`, false);
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'add_membership_close');
    },

    onCloseLightboxSaveInformation() {
        this.$el.find(this.slctrs.lightboxSaveInformation).removeClass('open');
    },

    onContinueWithPrime() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'subscription_widget_prime-mem');
        this.onMemberButtonClick();
    },

    onDeleteMembership() {
        const membershipType = this.model.get('membershipType');
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, `unlocked_remove_nag_prime_added_sce:${this.model.get('state')}`);
        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-edit',
            Odigeo._.bind(this.onDeleteMembershipAction, this),
            Odigeo._.bind(this.onDeleteMembershipCancel, this),
            {...this.buildLightboxTextKeys(membershipType)},
        );
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'unlocked_remove_nag');
    },

    onDeleteMembershipAction() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, `unlocked_remove_nag_confirm_prime_added_sce:${this.model.get('state')}`);
        const primeSuffix = (this.options.isPriceWithoutDiscountSelected ? 'np' : 'p');
        const isLoggedInSuffix = Odigeo._.endsWith(this.model.get('state'), '-log') ? '-log' : '';
        this.model.set('state', `remove-${primeSuffix}${isLoggedInSuffix}`);
        this.deleteMembership();
    },

    onDeleteMembershipCancel() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED,
            `unlocked_remove_nag_cancel_prime_added_sce:${this.model.get('state')}`
        );
        Odigeo.trigger('closeAllPopUps');
    },

    onForcedSelectionMemberChange(e) {
        const action = e.currentTarget.id === 'membership-member-price' ? 'prime-mem' : 'non-mem';
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'forced_selection_' + action);
        Odigeo.trigger(`${this.widget.id}:setForceSelectionPriceDiscount`, Odigeo._.isEqual(action, 'non-mem'));
    },

    membershipPerksOpen() {
        Odigeo.trigger(`${this.widget.id}:openMembershipPerksInfoLightbox`);
        Odigeo.trigger(`${this.widget.id}:openOrCloseMembershipDialog`, true);
    },

    onMembershipPerksLink() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, `know_more_clicked_pax_sce:${this.model.get('state')}`);
        this.membershipPerksOpen();
    },

    onMembershipWidgetLogin(e) {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'login_clicked');
        Odigeo.trigger(`${this.widget.id}:openLoginForm`, e);
    },

    onMemberButtonClick() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'add_membership_clicked');
        this.getMemberClick();
    },

    onOpenLoginForm(e) {
        this.trackGetMembershipLightBox('click_member');
        this.onCloseLightboxMember();
        Odigeo.trigger(`${this.widget.id}:openLoginForm`, e);
    },

    onPasswordIconClick() {
        const $membershipPassword = this.$el.find(this.slctrs.membershipPassword);
        const [typePassword, type, typeText] = ['password', 'type', 'text'];
        this.$el.find(this.slctrs.passwordViewerIcon).toggleClass('odf-hidden');
        $membershipPassword.attr(type, $membershipPassword.attr(type) === typePassword ? typeText : typePassword);
    },

    onSaveInformationClick() {
        this.$el.find(this.slctrs.lightboxSaveInformation).addClass('open');
    },

    clearPasswordErrors() {
        this.$el.find(this.slctrs.membershipPasswordContainer).removeClass('invalid');
        this.$el.find(this.slctrs.membershipPasswordError).addClass('odf-hidden');
    },

    getMemberClick() {
        Odigeo.trigger(`${this.widget.id}:launchTravellersValidations`);
    },

    hasToContinue() {
        return !this.$el.find(this.slctrs.membershipMemberPrice).is(':checked');
    },

    highlightOptions() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, 'forced_selection_error');
    },

    isAnyPriceSelected() {
        return this.$el.find(this.slctrs.membershipMemberPrice).is(':checked') ||
            this.$el.find(this.slctrs.membershipNonMemberPrice).is(':checked');
    },

    openLightBox(mustAppearDisclaimer) {
        this.alertDisclaimer(mustAppearDisclaimer);
        if (!mustAppearDisclaimer) {
            Odigeo.UIElements.toggleWidgetsDialogs(this.widget.id, true);
            Odigeo.trigger(`${this.widget.id}:getTravellersSelected`);
            this.$el.find(this.$cachedSelectors.lightboxSelector).addClass('open');
            this.clearPasswordErrors();
            Odigeo.trigger(`${this.widget.id}:openOrCloseMembershipDialog`, true);
            loginValidator.clearErrors(this.$el.find(this.slctrs.allInputs));
        }
    },

    setMemberSelected() {
        this.model.set({
            password: this.$el.find(this.slctrs.membershipPassword).val(),
            memberSelected: this.$el.find(this.slctrs.memberSelectTravellers).val(),
        });
    },

    updateState(isLogged) {
        let state = this.model.get('state');
        this.model.set('state', isLogged ?
            !Odigeo._.endsWith(state, '-log') ? `${state}-log` : state
            : state.replace('-log', ''));
    },

    showLoginLink(isLogged) {
        this.$el.find(this.slctrs.alreadyAMember).toggleClass('odf-hidden', isLogged);
    },

    showPasswordError(error) {
        this.clearPasswordErrors();
        this.$el.find(this.slctrs.membershipPasswordContainer).addClass('invalid');
        this.$el.find(this.slctrs.membershipPasswordError + '[data-error="' + error.key + '"]').removeClass('odf-hidden');
    },

    showWidget() {
        if (this.checkConditionToShowWidget(this.options)) {
            this.renderProductBasicFactory();
        }
    },

    getTitlePre(variation, titlePre, membershipDiscount, flightPrice) {
        const titlePrePrice = variation === VARIATIONS.VARIATION_2 ? membershipDiscount : flightPrice;
        if (variation === VARIATIONS.VARIATION_5) {
            return Odigeo.Utils.replaceCmsKeyArgs(titlePre, priceUtils.getPriceNoWrap(membershipDiscount));
        }
        return Odigeo.Utils.replaceCmsKeyArgs(titlePre, priceUtils.getPriceNoWrap(titlePrePrice));
    },

    buildPerksIconArray(perksNames) {
        const perksList = [];
        perksNames.forEach((perk) => {
            perksList.push({name: perk});
        });
        return perksList;
    },

    conditionsGroup5FreeTrial(param) {
        return param.isPrimeMobile;
    },

    conditionsGroup(param) {
        return param.discount > MIN_DISCOUNT;
    },

    conditionsGroup3(param) {
        return param.discount + (param.subscriptionPrice / 2) < 0 && param.discount + param.subscriptionPrice > 0;
    },

    conditionsGroup2(param) {
        return param.subscriptionPrice + param.discount < 0;
    },

    buildTitleNew(variation) {
        return `titleNew${variation}`;
    },

    getVariation(param) {
        if (this.conditionsGroup5FreeTrial(param)) {
            return VARIATIONS.VARIATION_5;
        } else if (this.conditionsGroup2(param)) {
            return VARIATIONS.VARIATION_2;
        } else if (this.conditionsGroup3(param)) {
            return VARIATIONS.VARIATION_3;
        }
        return VARIATIONS.VARIATION_4;
    },

    getGroup() {
        return Odigeo._.get(this.options, 'variation', 1);
    },

    buildParams() {
        const {membershipDiscountNumber} = this.options;
        const subscriptionPrice = Number(this.model.get('allPriceFromBackend'));
        const formattedPrice = Odigeo.Utils.formatCurrency(subscriptionPrice);
        const discount = Number(this.options.membershipDiscountNumber);
        const providerPrice = Number(this.options.providerPrice);
        const flightPrice = Odigeo.Utils.formatCurrency(providerPrice + discount);
        const flightPriceNoFormat = providerPrice + discount;
        const membershipDiscount = Odigeo.Utils.formatCurrency(discount);
        const isPrimeMobile = Odigeo.Membership.isPrimeMobile;
        return {
            subscriptionPrice,
            discount,
            flightPrice,
            flightPriceNoFormat,
            providerPrice,
            isPrimeMobile,
            membershipDiscount,
            formattedPrice,
            membershipDiscountNumber,
        };
    },

    replaceArgsLightboxKeys(keys, formattedPrice) {
        const priceNoWrap = priceUtils.getPriceNoWrap(formattedPrice);
        return {
            lightboxHeader: Odigeo.Utils.replaceCmsKeyArgs(keys.lightboxHeader, priceNoWrap),
            lightboxSubHeader: Odigeo.Utils.replaceCmsKeyArgs(keys.lightboxSubHeader, priceNoWrap),
            headerFreeAccount: Odigeo.Utils.replaceCmsKeyArgs(keys.headerFreeAccount, priceNoWrap),
            headerSubTitle: Odigeo.Utils.replaceCmsKeyArgs(keys.headerSubTitle, priceNoWrap),
        };
    },

    replaceArgsProductBasicReducedKeys(keys, formattedPrice, membershipDiscount) {
        const formattedPriceNoWrap = priceUtils.getPriceNoWrap(formattedPrice);
        const membershipDiscountNoWrap = priceUtils.getPriceNoWrap(membershipDiscount);
        const {expandableTitle, membershipPrice, reducedTitle} = keys;
        return {
            expandableTitle: Odigeo.Utils.replaceCmsKeyArgs(expandableTitle, membershipDiscountNoWrap),
            membershipPrice: Odigeo.Utils.replaceCmsKeyArgs(membershipPrice, formattedPriceNoWrap),
            reducedTitle: Odigeo.Utils.replaceCmsKeyArgs(reducedTitle, membershipDiscountNoWrap),
        };
    },

    replaceArgsProductBasicKeys(keys, formattedPrice, membershipDiscount) {
        const formattedPriceNoWrap = priceUtils.getPriceNoWrap(formattedPrice);
        const membershipDiscountNoWrap = priceUtils.getPriceNoWrap(membershipDiscount);
        const {membershipFlightPriceFmtd, priceWithoutDiscountNumberFmtd} = this.options;
        const {basicButton, titlePre, titlePost, titleNew, memberHeaderPrice} = keys;
        return {
            basicButton: Odigeo.Utils.replaceCmsKeyArgs(basicButton, formattedPriceNoWrap),
            titlePre: Odigeo.Utils.replaceCmsKeyArgs(titlePre, membershipDiscountNoWrap),
            titlePost: Odigeo.Utils.replaceCmsKeyArgs(titlePost, membershipDiscountNoWrap),
            memberHeaderPrice: Odigeo.Utils.replaceCmsKeyArgs(memberHeaderPrice, formattedPriceNoWrap),
            titleNew: Odigeo.Utils.replaceCmsKeyArgs(titleNew, membershipDiscountNoWrap,
                membershipFlightPriceFmtd, priceWithoutDiscountNumberFmtd
            ),
        };
    },

    deleteMembership() {
        this.trigger('updateProduct', 'remove');
        this.$cachedSelectors.productAddedSelector.empty();
        this.renderProductBasicFactory();
    },

    solveAddMembershipError(error) {
        this.deleteMembership();
        if (!Odigeo._.isEmpty(error) && error.code === 'UNL_MEMBERSHIP_ALREADY_MEMBER') {
            trackingUtils.trackEvent('sso_pax_page', 'go_to_login');
            Odigeo.trigger(`${this.widget.id}:openLoginForm`);
        }
    },

    onTermsAndConditionsClick() {
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, `unlocked_terms_and_conditions_sce:${this.model.get('state')}`);
    },

    trackContinueToPayment() {
        const userDTO = this.model.get('userDTO');
        let trackLabelScenario = this.model.get('scenario');
        if (Odigeo._.isEmpty(this.model.get('scenario'))) {
            if (!Odigeo._.isEmpty(userDTO)) {
                this.updateScenario({status: isUserDTOMember(userDTO) ? 'PREMIUM' : userDTO.source});
                trackLabelScenario = this.model.get('scenario');
            } else {
                trackLabelScenario = 'no-log-no-sub';
            }
        }
        trackingUtils.trackEvent(TRACKING_ACTION_UNLOCKED, `prime_mem_continue_${trackLabelScenario}_sce:${this.model.get('state')}`);
    },

    isGroupHigher(variation) {
        return variation === VARIATIONS.VARIATION_2 || variation === VARIATIONS.VARIATION_5;
    },

    buildProductBasicKeys(membershipType, membershipDiscountNumber) {
        const param = this.buildParams();
        const variation = this.getVariation(param);
        const variationTitle = this.conditionsGroup(param) ? VARIATIONS.VARIATION_1 : variation;
        const titleNew = this.buildTitleNew(variationTitle);
        const footer = Odigeo._.includes([VARIATIONS.VARIATION_2, VARIATIONS.VARIATION_3], variation) ? `footer${ variation }` : '';
        const perksNames = ['perkOne', 'perkTwo', 'perkThree', 'perkFour'];
        const perksList = this.buildPerksIconArray(perksNames);
        const isGroupHigher = this.isGroupHigher(variation);
        this.options.variation = variation;
        return {
            membershipDiscount: membershipDiscountNumber,
            footer,
            perksNew: {
                perkOne: this.keys[getKeyMembershipType('perkOneNew', membershipType)],
                perkTwo: this.keys[getKeyMembershipType('perkTwoNew', membershipType)],
                perkThree: this.keys[getKeyMembershipType('perkThreeNew', membershipType)],
                perkFour: this.keys[getKeyMembershipType('perkFourNew', membershipType)],
            },
            perksLink: this.keys[getKeyMembershipType('perksLink', membershipType)],
            memberHeaderPrice: this.keys[getKeyMembershipType('memberHeaderPrice', membershipType)],
            basicButtonNew: this.keys[getKeyMembershipType('basicButtonNew', membershipType)],
            basicButton: this.keys[`basicButton${variation}`],
            titleNew: this.keys[getKeyMembershipType(titleNew, membershipType)],
            variation,
            perksList,
            groupHigher: isGroupHigher,
        };
    },

    buildProductBasicReducedKeys() {
        const param = this.buildParams();
        this.options.variation = this.getVariation(param);
        const {expandableTitle, reducedTitle, membershipPrice,
            knowMore, subscribeButton, reducedPerkOne,
            reducedPerkTwo, reducedPerkThree, reducedPerkFour} = this.keys;
        return {
            expandableTitle, reducedTitle, membershipPrice,
            knowMore, subscribeButton,
            perks: {
                perkOne: reducedPerkOne,
                perkTwo: reducedPerkTwo,
                perkThree: reducedPerkThree,
                perkFour: reducedPerkFour,
            },
        };
    },

    buildLightboxKeys(membershipType) {
        return {
            ...this.keys,
            disclaimers: {
                disclaimerNotLogged: this.keys[getKeyMembershipType('disclaimerNotLogged', membershipType)],
                disclaimerSoftLogged: this.keys[getKeyMembershipType('disclaimerSoftLogged', membershipType)],
                disclaimerLoggedIn: this.keys[getKeyMembershipType('disclaimerLoggedIn', membershipType)],
            },
            legal: {
                legalLinkHref: this.keys[getKeyMembershipType('legalLinkHref', membershipType)],
            },
            lightboxHeader: this.keys[getKeyMembershipType('lightboxHeader', membershipType)],
            lightboxSubHeader: this.keys[getKeyMembershipType('lightboxSubHeader', membershipType)],
            headerFreeAccount: this.keys[getKeyMembershipType('headerFreeAccount', membershipType)],
            lightboxHeaderMember: this.keys[getKeyMembershipType('lightboxHeaderMember', membershipType)],
            headerSubTitle: this.keys[getKeyMembershipType('headerSubTitle', membershipType)],
        };
    },

    buildLightboxTextKeys(membershipType) {
        return {
            headerTitle: this.keys[getKeyMembershipType('lightboxTextsHeader', membershipType)],
            description: this.keys[getKeyMembershipType('lightboxTextsDescription', membershipType)],
            primaryButton: this.keys[getKeyMembershipType('lightboxTextsPrimary', membershipType)],
            secondaryButton: this.keys[getKeyMembershipType('lightboxTextsSecondary', membershipType)],
        };
    },
});
